module.exports = __webpack_public_path__ + "static/media/menu-icon.1f4106c1.svg";